import type { ComponentType } from "react";
import UsersContainer from "../views/pages/components/User/UsersContainer";

import AddCategorieContainer from "../views/pages/components/Categories/AddCategorieContainer";


import UpdateCategoriesContainer from "../views/pages/components/Categories/UpdateCategoriesContainer";

import GlobalProductsContainer from "../views/pages/components/Product/GlobalProductsContainer";

import ManageProductPropertiesContainer from "../views/pages/components/Product/ManageProductPropertiesContainer";
import AddUserContainer from "../views/pages/components/User/adding-user/AddUserContainer";
import SiteSelector from "../views/pages/components/SiteSelector";

//client

import AddNewClientContainer from "../views/pages/components/Client/AddNewClientContainer";


import DisplayClientsContainer from "../views/pages/components/Client/DisplayClientsContainer";

//Media Gallery
import IndexTemplate from "../views/pages/components/GlobalTools/template/IndexTemplate";
import DesignContainer from "../views/pages/components/GlobalTools/design/DesignContainer";
//site

import DisplaySitesContainer from "../views/pages/components/Site/ManageSites/DisplaySitesContainer";

import AddNewSiteContainer from "../views/pages/components/Site/ManageSites/AddNewSiteContainer";


import UpdateSiteContainer from "../views/pages/components/Site/ManageSites/UpdateSiteContainer";


import SiteConfigurationContainer from "../views/pages/components/Site/SiteConfiguration/SiteConfigurationContainer";
//Categories

import SiteCategoriesContainer from "../views/pages/components/Categories/SiteCategoriesContainer";
import LabelCategories from "../views/pages/components/Categories/LabelCategories";
import ScoreConfig from "../views/pages/components/Categories/ScoreConfig";
//import ManagePublish from "../views/pages/components/Publish/ManagePublish";

import SiteBlogContainer from "../views/pages/components/Blog/SiteBlogContainer";


import SitePostsContainer from "../views/pages/components/Blog/SitePostsContainer";

import CreatePostContainer from "../views/pages/components/Blog/createpostContainer";

import CreateBlogContainer from "../views/pages/components/Blog/createblogContainer";


import UpdateProductPropertiesContainer from "../views/pages/components/Product/UpdateProductPropertiesContainer";

import AddProductPropertiesContainer from "../views/pages/components/Product/AddProductPropertiesContainer";
// Pages

import UpdatePageContainer from "../views/pages/components/PagesComponent/UpdatePage/UpdatePageContainer";
import UpdatePageContent from "../views/pages/components/PagesComponent/UpdatePage/UpdatePageContent";
import UpdateTranslatePageContainer from "../views/pages/components/TranslatePages/UpdateTranslatePageContainer";

// UpdatePageHeaderFooter
import UpdatePageHeaderFooterContainer from "../views/pages/components/PagesComponent/UpdatePage/UpdatePageHeaderFooterContainer";


import UpdateProductContainer from "../views/pages/components/Product/UpdateProductContainer";


import UpdatePostContainer from "../views/pages/components/Blog/UpdatePostContainer";


import EditPermissionContainer from "../views/pages/components/User/EditPermissionContainer";

import LoginContainer from "../views/pages/components/LoginContainer";


import ManagePropertiesContainer from "../views/pages/components/Categories/ManagePropertiesContainer";

import VariableContainer from "../views/pages/components/GlobalTools/variable/VariableContainer";

import UpdateClientContainer from "../views/pages/components/Client/UpdateClientContainer";

import DisplayAdsContainer from "../views/pages/components/Product/ads/DisplayAdsContainer";
import ManagePublish from "../views/pages/components/ManagePublish/ManagePublish";
import DisplayPendingChangesContainer from "../views/pages/components/ManagePublish/DisplayPendingChangesContainer";
// SCRUM-1753: the held form submissions a reviewer releases or discards (admin only).
import HeldSubmissionsContainer from "../views/pages/components/HeldSubmissions/HeldSubmissionsContainer";
import ManageAds from "../views/pages/components/Ads/ManageAds";


import ProfileContainer from "../views/pages/components/ProfileContainer";
import DashboardContainer from "../views/pages/components/DashboardContainer"


import IndexMediaContainer from "../views/pages/components/Media/IndexMediaContainer";

import DisplayPagesContainer from "../views/pages/components/PagesComponent/PagesIndex/DisplayPagesContainer";
import TranslatePagesContainer from "../views/pages/components/TranslatePages/TranslatePagesContainer";
// history pages
import DisplayHistoriesPages from "../views/pages/components/PagesComponent/HistoriesPages/DisplayHistoriesPages";
import UpdateHistoriesPages from "../views/pages/components/PagesComponent/HistoriesPages/UpdateHistoriesPages";

import CreatePageContainer from "../views/pages/components/PagesComponent/PagesIndex/CreatePageContainer";

import AddGlobalProductContainer from "../views/pages/components/Product/AddGlobalProductContainer";

//client


import { getCurrentSiteUrl } from "../utils/currentSiteUrl";

/**
 * A screen: `AdminContainer` / `AuthContainer` mount `component` at `path`
 * under `layout`; `invisible` keeps it out of the sidebar.
 */
export type ScreenRoute = {
  path: string;
  name?: string;
  icon?: string;
  component: ComponentType;
  layout: "/admin" | "/auth";
  invisible?: boolean;
  collapse?: never;
  views?: never;
  target?: never;
};

/** A sidebar group: never routed itself, its `views` are. */
export type RouteGroup = {
  collapse: true;
  name: string;
  icon: string;
  state: string;
  path?: string;
  views: ScreenRoute[];
  component?: never;
  layout?: never;
  target?: never;
};

/** The "current site" sidebar link: opens the public site, mounts nothing. */
export type ExternalLinkRoute = {
  path: string;
  name: string;
  icon: string;
  layout: "/";
  target: "_blank";
  component?: never;
  collapse?: never;
  views?: never;
};

/** One row of a role's route table. */
export type AppRoute = ScreenRoute | RouteGroup | ExternalLinkRoute;

export const route_auth: AppRoute[] = [
  //auth
   {
    path: "/login",
    name: "Login",
    component: LoginContainer,
    layout: "/auth",
    invisible: true,
  },
];
export const routes_admin: AppRoute[] = [
  //auth
  {
    path: "/login",
    name: "Login",
     component: LoginContainer,
    layout: "/auth",
    invisible: true,
  },
  //profile
  {
    path: "/profile",
    name: "Profile",
    component : ProfileContainer,
    layout: "/admin",
    invisible: true,
  },
  //dashboard
  {
    icon: "ni ni-shop text-primary",
    path: "/dashboard",
    name: "Dashboard",
    component: DashboardContainer,
    layout: "/admin",
  },
  //current site
   {
    icon: "ni ni-curved-next text-primary",
    path: getCurrentSiteUrl(),
    name: "current site",
    target: "_blank",
    layout: "/",
  },
  //users
  {
    path: "/users",
    component:UsersContainer,
    layout: "/admin",
    name: "Users",
    icon: "ni ni-circle-08 text-primary",
  },

  // site selector
  //siteselector
  {
    path: "/siteselector",
    name: "Site Selector",
    icon: "ni ni-collection text-primary",
    component: SiteSelector,
    layout: "/admin",
  },

  
  //clients
  {
    collapse: true,
    path: "/clients",
    name: "Clients",
    icon: "ni ni-single-02 text-primary",
    state: "ClientCollapse",
    views: [
      {
        path: "/client/all",
        name: "Clients",
        component: DisplayClientsContainer,
        layout: "/admin",
      },
      {
        path: "/client/add-new",
        name: "New Client",
        component: AddNewClientContainer,
        layout: "/admin",
      },

      {
        path: "/client/update/:id",
        name: "Update",
        component: UpdateClientContainer,
        layout: "/admin",
        invisible: true,
      },
    ],
  },

  //global tools
  {
    collapse: true,
    name: "Global Tools",
    icon: "ni ni-settings-gear-65 text-primary ",
    state: "GlobalToolsCollapse",
    views: [
      {
        path: "/design",
        name: "Design",
        component: DesignContainer,
        layout: "/admin",
      },
      {
        path: "/template",
        name: "Template",
        component: IndexTemplate,
        layout: "/admin",
      },
      {
        path: "/variables",
        name: "Variables",
        component: VariableContainer,
        layout: "/admin",
      },
    ],
  },
  //site
  {
    collapse: true,
    name: "Site Tools",
    icon: "ni ni-settings text-primary",
    state: "SitesToolsCollapse",
    views: [
      {
        path: "/sites",
        name: "sites",
        component: DisplaySitesContainer,
        layout: "/admin",
      },
      {
        path: "/new-site",
        name: "New Site",
        component: AddNewSiteContainer,
        layout: "/admin",
      },

      {
        path: "/updating-site/:id",
        name: "UpdateSite",
        component: UpdateSiteContainer,
        layout: "/admin",
        invisible: true,
      },
      {
        path: "/site-configuration",
        name: " Site Configurations",
        component: SiteConfigurationContainer,
        layout: "/admin",
      },
    ],
  },

  //Categories
  {
    collapse: true,
    name: "Categories",
    icon: "ni ni-bullet-list-67 text-primary",
    state: "categorieCollapse",
    views: [
       {
        path: "/category/add",
        name: "create Category",
        component: AddCategorieContainer,
        layout: "/admin",
      },

      {
        path: "/category/update",
        name: "manage Categories",
        component: UpdateCategoriesContainer,
        layout: "/admin",
      },
      {
        path: "/category/properties",
        name: "Manage Properties",
        component: ManagePropertiesContainer,
        layout: "/admin",
      },
     
      {
        path: "/category/site",
        name: "Site Categories",
        component: SiteCategoriesContainer,
        layout: "/admin",
      },
      {
        path: "/category/label/:id",
        name: "Label Categories",
        component: LabelCategories,
        layout: "/admin",
        invisible: true,
      },
      // SCRUM-1850: administrators only — the weights decide the score every
      // visitor sees, and the server refuses an editor's save (SCRUM-1847).
      {
        path: "/category/score/:id",
        name: "Scoring",
        component: ScoreConfig,
        layout: "/admin",
        invisible: true,
      },
      
    ],
  },
  //Products
  {
    collapse: true,
    name: "Product",
    icon: "ni ni-shop text-primary",
    state: "productCollapse",
    views: [
       {
        path: "/globalproducts",
        name: "Products",
        component: GlobalProductsContainer,
        layout: "/admin",
      },
       {
        path: "/add-product",
        name: "New Product",
        component: AddGlobalProductContainer,
        layout: "/admin",
      },
     
     
      {
        path: "/update-product/:id/:countrycode",
        component: UpdateProductContainer,
        layout: "/admin",
        invisible: true,
      },
      {
        path: "/addproductproperties",
        name: "Set Initial Product Properties",
        component: AddProductPropertiesContainer,
        layout: "/admin",
        // invisible: true,
      },

      {
        path: "/productproperties",
        name: "Edit Product Properties",
        component: ManageProductPropertiesContainer,
        layout: "/admin",
      },


      {
        path: "/updateproductproperties/:id",
        name: "UpdateProductProperties",
        component: UpdateProductPropertiesContainer,
        layout: "/admin",
        invisible: true,
      },
     
      {
        path: "/ads/:id",
        name: "Ads",
        component: DisplayAdsContainer,
        layout: "/admin",
        invisible: true,
      },
    ],
  },

  {
    path: "/update-pg/:id",
    component: UpdatePageContainer,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/update-translate-page/:id",
    component: UpdateTranslatePageContainer,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/update-page-content/:id",
    component: UpdatePageContent,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/update-required-pg/:id",
    component: UpdatePageHeaderFooterContainer,
    layout: "/admin",
    invisible: true,
  },
    //Post
  {
    collapse: true,
    name: "Post",
    icon: "ni ni-ungroup text-primary",
    state: "PostCollapse",
    views: [
     
      
       {
        path: "/posts",
        name: "Posts",
        component: SitePostsContainer,
        layout: "/admin",
      },
      {
        path: "/create-post",
        name: "New Post",
        component: CreatePostContainer,
        layout: "/admin",
      },
    ],
  },
  //Blog
  {
    collapse: true,
    name: "Blog",
    icon: "ni ni-ungroup text-primary",
    state: "BlogCollapse",
    views: [
     
      {
        path: "/blog",
        name: "Blogs",
        component: SiteBlogContainer,
        layout: "/admin",
      },
       {
        path: "/create-blog",
        name: "New Blog",
        component: CreateBlogContainer,
        layout: "/admin",
      },
    ],
  },
 
  
  //Ads
  {
    collapse: true,
    name: "Ads",
    icon: "fas fa-ad text-primary",
    state: "AdsCollapse",
    views: [
      
      {
        path: "/ads",
        name: "Ads",
        component: ManageAds,
        layout: "/admin",
      },
       
    ],
  },
  
  //page
  {
    collapse: true,
    name: "Pages",
    icon: "ni ni-single-copy-04 text-primary",
    state: "PagesCollapse",
    views: [
      
      {
        path: "/display-pages",
        name: "Pages",
        component: DisplayPagesContainer,
        layout: "/admin",
      },
      {
        path: "/create-pages",
        name: "New Page",
        component: CreatePageContainer,
        layout: "/admin",
      },
      {
        path: "/translate-pages",
        name: "Translate Pages",
        component: TranslatePagesContainer,
        layout: "/admin",
      },
      {
        path: "/update-history-pg/:id",
        component: UpdateHistoriesPages,
        layout: "/admin",
        invisible: true,
      },

      
    ],
  },
  {
    path: "/update-post/:id",
    component: UpdatePostContainer,
    layout: "/admin",
    invisible: true,
  },
  // Manage Publish
  {
    collapse: true,
    name: "Publishing",
    icon: "ni ni-check-bold text-primary",
    state: "PublishCollapse",
    views: [
      {
        path: "/managepublish",
        name: "Publish Pages",
        component: ManagePublish,
        layout: "/admin",
      },
      {
        path: "/updated-pages",
        name: "Pending Pages",
        component: DisplayHistoriesPages,
        layout: "/admin",
      },
      {
        path: "/pending-changes",
        name: "Pending Changes",
        component: DisplayPendingChangesContainer,
        layout: "/admin",
      },
      {
        path: "/held-submissions",
        name: "Held submissions",
        component: HeldSubmissionsContainer,
        layout: "/admin",
      },
    ],
  },

  {
    path: "/add-user",
    name: "Adding user cont",
    component: AddUserContainer,
    layout: "/admin",
    invisible: true,
  },
  //permission
  {
    path: "/update-permission/:id",
    component: EditPermissionContainer,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/Media",
    name: "Media files",
    icon: "ni ni-album-2 text-primary",
    component: IndexMediaContainer,
    layout: "/admin",
  },
];

//publish content : publish & pages
export const routes_content_editor: AppRoute[] = [
  //auth
  {
    path: "/login",
    name: "Login",
     component: LoginContainer,
    layout: "/auth",
    invisible: true,
  },
  //profile
  {
    path: "/profile",
    name: "Profile",
    component : ProfileContainer,
    layout: "/admin",
    invisible: true,
  },
  //dashboard
  {
    icon: "ni ni-shop text-primary",
    path: "/dashboard",
    name: "Dashboard",
    component: DashboardContainer,
    layout: "/admin",
  },
  //current site
  {
    icon: "ni ni-curved-next text-primary",
    path: getCurrentSiteUrl(),
    name: "current site",
    target: "_blank",
    layout: "/",
  },

  // manage pages
  {
    collapse: true,
    name: "Pages",
    icon: "ni ni-single-copy-04 text-primary",
    state: "PagesCollapse",
    views: [
      {
        path: "/display-pages",
        name: "Available Pages",
        component: DisplayPagesContainer,
        layout: "/admin",
      },
      {
        path: "/update-history-pg/:id",
        component: UpdateHistoriesPages,
        layout: "/admin",
        invisible: true,
      },

      {
        path: "/create-pages",
        name: "Create Page",
        component: CreatePageContainer,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/update-pg/:id",
    component: UpdatePageContainer,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/update-translate-page/:id",
    component: UpdateTranslatePageContainer,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/update-page-content/:id",
    component: UpdatePageContent,
    layout: "/admin",
    invisible: true,
  },
    // Manage Publish
  {
    collapse: true,
    name: "Manage Publish",
    icon: "ni ni-check-bold text-primary",
    state: "PublishCollapse",
    views: [
      {
        path: "/updated-pages",
        name: "Pending Pages",
        component: DisplayHistoriesPages,
        layout: "/admin",
      },   
    ],
  },

  //manage Blog
  // Post menu — geeft editor toegang tot Posts + New Post (create-post)
  {
    collapse: true,
    name: "Post",
    icon: "ni ni-ungroup text-primary",
    state: "PostCollapse",
    views: [
      {
        path: "/posts",
        name: "Posts",
        component: SitePostsContainer,
        layout: "/admin",
      },
      {
        path: "/create-post",
        name: "New Post",
        component: CreatePostContainer,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/update-post/:id",
    component: UpdatePostContainer,
    layout: "/admin",
    invisible: true,
  },

  {
    path: "/Media",
    name: "Media files",
    icon: "ni ni-album-2 text-primary",
    component: IndexMediaContainer,
    layout: "/admin",
  },
];
//pages //catg & sub //publish
export const routes_content_coordinator: AppRoute[] = [
  //auth
  {
    path: "/login",
    name: "Login",
     component: LoginContainer,
    layout: "/auth",
    invisible: true,
  },
  //profile
  {
    path: "/profile",
    name: "Profile",
    component : ProfileContainer,
    layout: "/admin",
    invisible: true,
  },
  //dashboard
  {
    icon: "ni ni-shop text-primary",
    path: "/dashboard",
    name: "Dashboard",
    component: DashboardContainer,
    layout: "/admin",
  },
  //current site
   {
    icon: "ni ni-curved-next text-primary",
    path: getCurrentSiteUrl(),
    name: "current site",
    target: "_blank",
    layout: "/",
  },
  // maange clients
  //clients
  {
    collapse: true,
    path: "/clients",
    name: "Clients",
    icon: "ni ni-single-02 text-primary",
    state: "ClientCollapse",
    views: [
      {
        path: "/client/all",
        name: "Display Clients",
        component: DisplayClientsContainer,
        layout: "/admin",
      },
      {
        path: "/client/add-new",
        name: "Add New Client",
        component: AddNewClientContainer,
        layout: "/admin",
      },

      {
        path: "/client/update/:id",
        name: "Update",
        component: UpdateClientContainer,
        layout: "/admin",
        invisible: true,
      },
    ],
  },
  // manage global tools
  //global tools
  {
    collapse: true,
    name: "Global Tools",
    icon: "ni ni-settings-gear-65 text-primary ",
    state: "GlobalToolsCollapse",
    views: [
      {
        path: "/design",
        name: "Design",
        component: DesignContainer,
        layout: "/admin",
      },
      {
        path: "/template",
        name: "Template",
        component: IndexTemplate,
        layout: "/admin",
      },
      {
        path: "/variables",
        name: "Variables",
        component: VariableContainer,
        layout: "/admin",
      },
    ],
  },
  // manage page
  //page
  {
    collapse: true,
    name: "Pages",
    icon: "ni ni-single-copy-04 text-primary",
    state: "PagesCollapse",
    views: [
      {
        path: "/display-pages",
        name: "Available Pages",
        component: DisplayPagesContainer,
        layout: "/admin",
      },
      {
        path: "/update-history-pg/:id",
        component: UpdateHistoriesPages,
        layout: "/admin",
        invisible: true,
      },

      {
        path: "/create-pages",
        name: "Create Page",
        component: CreatePageContainer,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/update-pg/:id",
    component: UpdatePageContainer,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/update-translate-page/:id",
    component: UpdateTranslatePageContainer,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/update-page-content/:id",
    component: UpdatePageContent,
    layout: "/admin",
    invisible: true,
  },
  // manage publish content
  //publish
  // Manage Publish
  {
    collapse: true,
    name: "Manage Publish",
    icon: "ni ni-check-bold text-primary",
    state: "PublishCollapse",
    views: [
      {
        path: "/managepublish",
        name: "Publish Pages",
        component: ManagePublish,
        layout: "/admin",
      },
      {
        path: "/updated-pages",
        name: "Pending Pages",
        component: DisplayHistoriesPages,
        layout: "/admin",
      },   
    ],
  },
  //Manage Products & Categories
  //Categories
  {
    collapse: true,
    name: "Categories",
    icon: "ni ni-bullet-list-67 text-primary",
    state: "categorieCollapse",
    views: [
      {
        path: "/category/properties",
        name: "Manage Properties",
        component: ManagePropertiesContainer,
        layout: "/admin",
      },
      {
        path: "/category/add",
        name: "Add Category",
        component: AddCategorieContainer,
        layout: "/admin",
      },
      {
        path: "/category/update",
        name: "Update Categories",
        component: UpdateCategoriesContainer,
        layout: "/admin",
      },
      {
        path: "/category/site",
        name: "Site Categories",
        component: SiteCategoriesContainer,
        layout: "/admin",
      },
    ],
  },
  //Products
  {
    collapse: true,
    name: "Product",
    icon: "ni ni-shop text-primary",
    state: "productCollapse",
    views: [
      {
        path: "/globalproducts",
        name: "Products",
        component: GlobalProductsContainer,
        layout: "/admin",
      },
      {
        path: "/update-product/:id/:countrycode",
        component: UpdateProductContainer,
        layout: "/admin",
        invisible: true,
      },

      {
        path: "/productproperties",
        name: "Manage Product Properties",
        component: ManageProductPropertiesContainer,
        layout: "/admin",
      },

      {
        path: "/updateproductproperties/:id",
        name: "UpdateProductProperties",
        component: UpdateProductPropertiesContainer,
        layout: "/admin",
        invisible: true,
      },
      {
        path: "/addproductproperties",
        name: "UpdateProductProperties",
        component: AddProductPropertiesContainer,
        layout: "/admin",
        invisible: true,
      },
      {
        path: "/ads/:id",
        name: "Ads",
        component: DisplayAdsContainer,
        layout: "/admin",
        invisible: true,
      },
      
    ],
  },
//manage tags 

  // manage blog
  //Blog
  {
    collapse: true,
    name: "Blog",
    icon: "ni ni-ungroup text-primary",
    state: "BlogCollapse",
    views: [
      {
        path: "/posts",
        name: "Manage Posts",
        component: SitePostsContainer,
        layout: "/admin",
      },
      {
        path: "/blog",
        name: "Manage Blog",
        component: SiteBlogContainer,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/update-post/:id",
    component: UpdatePostContainer,
    layout: "/admin",
    invisible: true,
  },

  


  {
    path: "/Media",
    name: "Media files",
    icon: "ni ni-album-2 text-primary",
    component: IndexMediaContainer,
    layout: "/admin",
  },
];
//admin - users
export const routes_content_director: AppRoute[] = [
  //auth
  {
    path: "/login",
    name: "Login",
     component: LoginContainer,
    layout: "/auth",
    invisible: true,
  },
  //profile
  {
    path: "/profile",
    name: "Profile",
    component : ProfileContainer,
    layout: "/admin",
    invisible: true,
  },
  //dashboard
  {
    icon: "ni ni-shop text-primary",
    path: "/dashboard",
    name: "Dashboard",
    component: DashboardContainer,
    layout: "/admin",
  },
  //current site
  {
    icon: "ni ni-curved-next text-primary",
    path: getCurrentSiteUrl(),
    name: "current site",
    target: "_blank",
    layout: "/",
  },
  // manage global tools
  //global tools
  {
    collapse: true,
    name: "Global Tools",
    icon: "ni ni-settings-gear-65 text-primary ",
    state: "GlobalToolsCollapse",
    views: [
      {
        path: "/design",
        name: "Design",
        component: DesignContainer,
        layout: "/admin",
      },
      {
        path: "/template",
        name: "Template",
        component: IndexTemplate,
        layout: "/admin",
      },
      {
        path: "/variables",
        name: "Variables",
        component: VariableContainer,
        layout: "/admin",
      },
    ],
  },

  //site configurations
  {
    collapse: true,
    name: "Site Tools",
    icon: "ni ni-settings text-primary",
    state: "SitesToolsCollapse",
    views: [
      {
        path: "/site-configuration",
        name: " Site Configurations",
        component: SiteConfigurationContainer,
        layout: "/admin",
      },
    ],
  },

  //Manage Products & Categories
  //Categories
  {
    collapse: true,
    name: "Categories",
    icon: "ni ni-bullet-list-67 text-primary",
    state: "categorieCollapse",
    views: [
      {
        path: "/category/properties",
        name: "Manage Properties",
        component: ManagePropertiesContainer,
        layout: "/admin",
      },
      {
        path: "/category/add",
        name: "Add Category",
        component: AddCategorieContainer,
        layout: "/admin",
      },
      {
        path: "/category/update",
        name: "Update Categories",
        component: UpdateCategoriesContainer,
        layout: "/admin",
      },
      {
        path: "/category/site",
        name: "Site Categories",
        component: SiteCategoriesContainer,
        layout: "/admin",
      },
    ],
  },
  //Products
  {
    collapse: true,
    name: "Product",
    icon: "ni ni-shop text-primary",
    state: "productCollapse",
    views: [
      {
        path: "/globalproducts",
        name: "Products",
        component: GlobalProductsContainer,
        layout: "/admin",
      },
      {
        path: "/update-product/:id/:countrycode",
        component: UpdateProductContainer,
        layout: "/admin",
        invisible: true,
      },
      {
        path: "/productproperties",
        name: "Manage Product Properties",
        component: ManageProductPropertiesContainer,
        layout: "/admin",
      },

      {
        path: "/updateproductproperties/:id",
        name: "UpdateProductProperties",
        component: UpdateProductPropertiesContainer,
        layout: "/admin",
        invisible: true,
      },
      {
        path: "/addproductproperties",
        name: "UpdateProductProperties",
        component: AddProductPropertiesContainer,
        layout: "/admin",
        invisible: true,
      },
      {
        path: "/ads/:id",
        name: "Ads",
        component: DisplayAdsContainer,
        layout: "/admin",
        invisible: true,
      },
    ],
  },
  // maange clients
  //clients
  {
    collapse: true,
    path: "/clients",
    name: "Clients",
    icon: "ni ni-single-02 text-primary",
    state: "ClientCollapse",
    views: [
      {
        path: "/client/all",
        name: "Display Clients",
        component: DisplayClientsContainer,
        layout: "/admin",
      },
      {
        path: "/client/add-new",
        name: "Add New Client",
        component: AddNewClientContainer,
        layout: "/admin",
      },

      {
        path: "/client/update/:id",
        name: "Update",
        component: UpdateClientContainer,
        layout: "/admin",
        invisible: true,
      },
    ],
  },
  // manage page
  //page

  {
    collapse: true,
    name: "Pages",
    icon: "ni ni-single-copy-04 text-primary",
    state: "PagesCollapse",
    views: [
      {
        path: "/display-pages",
        name: "Available Pages",
        component: DisplayPagesContainer,
        layout: "/admin",
      },
      {
        path: "/update-history-pg/:id",
        component: UpdateHistoriesPages,
        layout: "/admin",
        invisible: true,
      },

      {
        path: "/create-pages",
        name: "Create Page",
        component: CreatePageContainer,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/update-pg/:id",
    component: UpdatePageContainer,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/update-translate-page/:id",
    component: UpdateTranslatePageContainer,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/update-page-content/:id",
    component: UpdatePageContent,
    layout: "/admin",
    invisible: true,
  },

  // manage blog
  //Blog
  {
    collapse: true,
    name: "Blog",
    icon: "ni ni-ungroup text-primary",
    state: "BlogCollapse",
    views: [
      {
        path: "/posts",
        name: "Manage Posts",
        component: SitePostsContainer,
        layout: "/admin",
      },
      {
        path: "/blog",
        name: "Manage Blog",
        component: SiteBlogContainer,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/update-post/:id",
    component: UpdatePostContainer,
    layout: "/admin",
    invisible: true,
  },
  // manage Ads

  // manage Media


  // Manage Publish
  {
    collapse: true,
    name: "Manage Publish",
    icon: "ni ni-check-bold text-primary",
    state: "PublishCollapse",
    views: [
      {
        path: "/managepublish",
        name: "Publish Pages",
        component: ManagePublish,
        layout: "/admin",
      },
      {
        path: "/updated-pages",
        name: "Pending Pages",
        component: DisplayHistoriesPages,
        layout: "/admin",
      },   
    ],
  },

 
  {
    path: "/Media",
    name: "Media files",
    icon: "ni ni-album-2 text-primary",
    component: IndexMediaContainer,
    layout: "/admin",
  },
];

//ads // siteproducts
export const routes_sales_manager: AppRoute[] = [
  //auth
  {
    path: "/login",
    name: "Login",
     component: LoginContainer,
    layout: "/auth",
    invisible: true,
  },
  //profile
  {
    path: "/profile",
    name: "Profile",
    component : ProfileContainer,
    layout: "/admin",
    invisible: true,
  },
  //dashboard
  {
    icon: "ni ni-shop text-primary",
    path: "/dashboard",
    name: "Dashboard",
    component: DashboardContainer,
    layout: "/admin",
  },
  //current site
  {
    icon: "ni ni-curved-next text-primary",
    path: getCurrentSiteUrl(),
    name: "current site",
    target: "_blank",
    layout: "/",
  },

  // manage global tools
  //global tools
  {
    collapse: true,
    name: "Global Tools",
    icon: "ni ni-settings-gear-65 text-primary ",
    state: "GlobalToolsCollapse",
    views: [
      {
        path: "/design",
        name: "Design",
        component: DesignContainer,
        layout: "/admin",
      },
      {
        path: "/template",
        name: "Template",
        component: IndexTemplate,
        layout: "/admin",
      },
    ],
  },

  //Manage Products & Categories
  //Products
  {
    collapse: true,
    name: "Product",
    icon: "ni ni-shop text-primary",
    state: "productCollapse",
    views: [
      {
        path: "/globalproducts",
        name: "Products",
        component: GlobalProductsContainer,
        layout: "/admin",
      },
      {
        path: "/update-product/:id/:countrycode",
        component: UpdateProductContainer,
        layout: "/admin",
        invisible: true,
      },

      {
        path: "/productproperties",
        name: "Manage Product Properties",
        component: ManageProductPropertiesContainer,
        layout: "/admin",
      },

      {
        path: "/updateproductproperties/:id",
        name: "UpdateProductProperties",
        component: UpdateProductPropertiesContainer,
        layout: "/admin",
        invisible: true,
      },
      {
        path: "/addproductproperties",
        name: "UpdateProductProperties",
        component: AddProductPropertiesContainer,
        layout: "/admin",
        invisible: true,
      },
      {
        path: "/ads/:id",
        name: "Ads",
        component: DisplayAdsContainer,
        layout: "/admin",
        invisible: true,
      },
    ],
  },
  // manage blog
  //Blog
  {
    collapse: true,
    name: "Blog",
    icon: "ni ni-ungroup text-primary",
    state: "BlogCollapse",
    views: [
      {
        path: "/posts",
        name: "Manage Posts",
        component: SitePostsContainer,
        layout: "/admin",
      },
      {
        path: "/blog",
        name: "Manage Blog",
        component: SiteBlogContainer,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/update-post/:id",
    component: UpdatePostContainer,
    layout: "/admin",
    invisible: true,
  },
  //Ads
  {
    collapse: true,
    name: "Ads",
    icon: "fas fa-ad text-primary",
    state: "AdsCollapse",
    views: [
      {
        path: "/ads",
        name: "Manage Ads",
        component: ManageAds,
        layout: "/admin",
      },
    ],
  },


];
